import { render, staticRenderFns } from "./PageSizeSelect.vue?vue&type=template&id=386897db&scoped=true"
import script from "./PageSizeSelect.vue?vue&type=script&lang=js"
export * from "./PageSizeSelect.vue?vue&type=script&lang=js"
import style0 from "./PageSizeSelect.vue?vue&type=style&index=0&id=386897db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386897db",
  null
  
)

export default component.exports